'use strict';

import React from 'react';

export default function IconEdit (props) {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2 13.7188V11.2813C2 11.1735 2.0428 11.0702 2.11899 10.994L11.869 1.24399C12.0276 1.08534 12.2849 1.08534 12.4435 1.24399L14.881 3.68149C15.0397 3.84014 15.0397 4.09736 14.881 4.25601L5.13101 14.006C5.05483 14.0822 4.95149 14.125 4.84375 14.125H2.40625C2.18188 14.125 2 13.9431 2 13.7188ZM4.67548 13.3125L14.0192 3.96874L12.1563 2.10576L2.8125 11.4495V13.3125H4.67548ZM2 15.3438C2 15.5681 2.18188 15.75 2.40625 15.75H10.5369C10.7613 15.75 10.9431 15.5681 10.9431 15.3438C10.9431 15.1194 10.7613 14.9375 10.5369 14.9375H2.40625C2.18188 14.9375 2 15.1194 2 15.3438Z" fill="#757575"/>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/ui/Icons/IconEdit.jsx